import ReactDOM from 'react-dom/client';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { LoadingProvider } from './components/globalloaders/LoadingContext';
import AuthBootstrap from './guard/AuthBootstrap';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <AuthBootstrap>
    <LoadingProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </LoadingProvider>
  </AuthBootstrap>
);